<template>
<div>
    <!-- <banner></banner> -->
    <div class="main">
    <div class="titleHeader">
      <img class="sizePressImg" src="../../assets/img/pei.png" alt="" />
      <span class="titleText">教材培训</span>
    </div>
    <div>
      <el-row  class="pressul clearfix" type="flex">
        <el-col 
          :span="6"
          class="pressli left"
          :key="index"
          v-for="(item, index) in pressData"
          
        >
          <div class="pressImgdiv">
            <img class="pressImg" :src="item.imagesUrl" alt="" />
          </div>
          <p class="pressNametext">{{ item.courseName }}</p>
          <div class="detailbtn" @click="gotoUrl(item.id)">了解详情</div>
        </el-col>
      </el-row>
      <div class="block">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          hide-on-single-page
          :page-size="pageParam.pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</div>
</template>
<script>
// import Banner from '@/components/home/banner.vue'
import { listTrain } from '../../api/index.js'
import { mapMutations, mapState, mapGetters } from 'vuex'
export default {
  // components: {
  //   Banner,
  // },
  data() {
    return {
      pageParam: {
        governmentId:"",
        pageNum: 1,
        pageSize: 8,
      },
      pressData: [],
      total: 0,
    }
  },
  computed: {
    ...mapGetters(['resStatus', 'resBookSelectionAuthority','resSchoolId']),
  },
  created() {
    this.pageParam.governmentId = this.resSchoolId ? this.resSchoolId :'';
    this.getDataList(this.pageParam)
  },
  methods: {
    getDataList(param) {
      listTrain(param)
        .then((res) => {
          if (res.status == 0) {
            this.pressData = res.data
            this.total = res.page.total
          }
        })
        .catch(() => {})
    },
    gotoUrl(id) {
      this.$router.push({
        path: '/traindetail',
        query: {
          id: id,
        },
      })
    },
    handleSizeChange(newSize) {},
    handleCurrentChange(newPage) {
      this.pageParam.pageNum = newPage
      this.getDataList(this.pageParam)
    },
  },
}
</script>

<style lang="scss" scoped>
.titleText {
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  font-size: 16px;
}
.sizePressImg {
  width: 26px;
  height: 19px;
  display: inline-block;
  vertical-align: middle;
}
.titleHeader {
  border-bottom: 1px solid #0082F0;
  height: 25px;
  margin-top: 20px;
}
.pressImg {
  width: 100%;
  height: 100%;
}
.pressNametext {
  font-size: 14px;
  height: 15px;
  // line-height: 25px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #888888;
  margin-top: 20px;
  margin-left: 20px;
}
.pressImgdiv {
  width: 100%;
  height: 180px;
  max-height: 180px;
  background: #ffffff;
  text-align: center;
}
.pressli:nth-child(4n) {
  margin-right: 0;
}
.pressul{
  margin-top: 20px;
  flex-wrap: wrap;
}
.pressli {
  width: 285px;
  height: 270px;
  margin-right: 20px;
  margin-bottom: 18px;
  background: white;
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  cursor: pointer;
}
.pressli:hover{
   border: 1px solid #FFB400;
}
.detailbtn{
  width: 70px;
  height: 20px;
  line-height: 20px;
  margin: 0 auto;
  margin-top: 15px;
  text-align: center;
  background: #0082F0;
  border-radius: 8px;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
</style>

